import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import type { FeatureFlagGuardProps } from './FeatureFlagGuard.types';

const FeatureFlagGuard = React.memo(
  ({ flag, children }: Readonly<FeatureFlagGuardProps>): React.ReactElement => {
    const flags = useFlags();
    const flagValue = flags[flag];

    if (!flagValue) {
      return <InlineFeedback type="not-found" />;
    }

    return <>{children}</>;
  }
);

FeatureFlagGuard.displayName = 'FeatureFlagGuard';

export { FeatureFlagGuard };
